import { configureStore } from "@reduxjs/toolkit"

import errorsReducer from "./reducers/errors"
import loaderReducer from "./reducers/loader"
import localStorageReducer from "./reducers/localStorage"

export default configureStore({
  reducer: {
    errors: errorsReducer,
    loader: loaderReducer,
    localStorage: localStorageReducer
  }
})